// src/components/AnagraficaCliente.jsx
import React, { useState } from "react";
import { authFetch } from "../utils/authFetch";
import { useNavigate } from "react-router-dom";
import TornaAlMenu from "./TornaAlMenu";

const AnagraficaCliente = ({
  cliente = {},
  onStoricoPunti,
  onStoricoConsumi,
  onStoricoWallet,
  onClienteAggiornato,
}) => {
  const navigate = useNavigate();

  const [editingEmail, setEditingEmail] = useState(false);
  const [newEmail, setNewEmail] = useState(cliente.email || "");
  const [savingEmail, setSavingEmail] = useState(false);
  const [emailMessage, setEmailMessage] = useState("");

  const punti = Number(cliente.points ?? cliente.loyalty_points ?? 0);

  const salvaNuovaEmail = async () => {
    const email = (newEmail || "").trim().toLowerCase();

    if (!email) {
      setEmailMessage("Inserisci una nuova email.");
      return;
    }

    if (!cliente?.code) {
      setEmailMessage("Cliente non caricato correttamente.");
      return;
    }

    const ok = window.confirm(
      `Confermi di cambiare l'email account da ${cliente.email || "-"} a ${email}?`
    );

    if (!ok) return;

    setSavingEmail(true);
    setEmailMessage("");

    try {
      const res = await authFetch(`/api/clienti/${cliente.code}/`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const json = await res.json().catch(() => ({}));

      if (!res.ok) {
        throw new Error(json?.detail || "Errore durante il cambio email.");
      }

      setEmailMessage(
        "✅ Email aggiornata correttamente.\nL'indirizzo di accesso all'app è stato aggiornato. Il cliente dovrà accedere con la nuova email utilizzando la stessa password."
      );

      setEditingEmail(false);

      if (onClienteAggiornato) {
        await onClienteAggiornato();
      }
    } catch (error) {
      setEmailMessage(error?.message || "Errore durante il cambio email.");
    } finally {
      setSavingEmail(false);
    }
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <button className="btn btn-outline-secondary" onClick={() => navigate("/clienti")}>
          ← Indietro
        </button>
        <TornaAlMenu to="/" />
      </div>

      <h3>🧍 Anagrafica Cliente</h3>

      <p><strong>Nome:</strong> {cliente.name || "-"}</p>
      <div className="mb-3">
        <p className="mb-2"><strong>Email:</strong> {cliente.email || "-"}</p>

        {!editingEmail ? (
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            onClick={() => {
              setNewEmail(cliente.email || "");
              setEmailMessage("");
              setEditingEmail(true);
            }}
          >
            Modifica email account
          </button>
        ) : (
          <div className="card border-0 bg-light mt-2" style={{ maxWidth: 520 }}>
            <div className="card-body p-3">
              <label className="form-label fw-semibold">Nuova email</label>

              <input
                type="email"
                className="form-control"
                value={newEmail}
                onChange={(e) => setNewEmail(e.target.value)}
                placeholder="nuova@email.it"
                disabled={savingEmail}
              />

              <div className="small text-muted mt-2">
                Per i clienti registrati dall'app verranno aggiornati anche email e username di accesso.
              </div>

              <div className="d-flex gap-2 mt-3">
                <button
                  type="button"
                  className="btn btn-success btn-sm"
                  onClick={salvaNuovaEmail}
                  disabled={savingEmail}
                >
                  {savingEmail ? "Salvataggio..." : "Salva nuova email"}
                </button>

                <button
                  type="button"
                  className="btn btn-outline-secondary btn-sm"
                  onClick={() => {
                    setEditingEmail(false);
                    setEmailMessage("");
                  }}
                  disabled={savingEmail}
                >
                  Annulla
                </button>
              </div>
            </div>
          </div>
        )}

        {emailMessage && (
          <div className="small mt-2" style={{ whiteSpace: "pre-line" }}>
            {emailMessage}
          </div>
        )}
      </div>
      <p><strong>Telefono:</strong> {cliente.phone || "-"}</p>
      <p><strong>Codice:</strong> {cliente.code || "-"}</p>
      <p><strong>Store:</strong> {cliente.store || "-"}</p>
      <p><strong>Tipo:</strong> {cliente.tipo || cliente.tipo_cliente || "-"}</p>

      <p>
        <strong>Punti:</strong>{" "}
        <span className="text-success">{punti.toFixed(2)}</span>
      </p>

      <div className="d-flex gap-2 mb-3 flex-wrap">
        <button
          className="btn btn-outline-warning btn-sm"
          onClick={onStoricoPunti}
        >
          📜 Storico Punti
        </button>

        <button
          className="btn btn-outline-primary btn-sm"
          onClick={onStoricoConsumi}
        >
          📦 Storico acquisti
        </button>

        <button
          type="button"
          className="btn btn-outline-success btn-sm"
          onClick={() => {
            console.log("CLICK WALLET");
            if (onStoricoWallet) onStoricoWallet();
          }}
        >
          💰 Storico Wallet
        </button>
      </div>
    </>
  );
};

export default AnagraficaCliente;
